export default {"src":"/_next/static/media/RIOT.c6450386.svg","height":18,"width":18};